import { Box, Lottie, Text } from '@bonanza-social/moonlight';
import { Trans } from '@bonanza-social/i18n';
import { memo, useEffect, useMemo } from 'react';
import { useDispatch } from '@bonanza-social/toolkit/state';
import {
  StatusInstructions,
  StatusResetDisclaimer,
  StatusTitleText,
} from '../../components';
import { StatusUpdatedProps } from './StatusUpdated.types';
import { Platform } from 'react-native';

function StatusUpdated({ variant, status }: StatusUpdatedProps) {
  const dispatch = useDispatch();
  const statusName = status?.playerStatus || 'Member';
  const statusColorProps = useMemo(
    () =>
      Platform.select({
        ios: { gradient: `darkSurfaceStatus${statusName}` },
        web: { gradient: `darkSurfaceStatus${statusName}` },
        android: { color: `darkSurfaceSolidStatus${statusName}` },
      }),
    [statusName],
  );

  useEffect(() => {
    Lottie.present({ animation: 'confetti' });
  }, [dispatch]);

  const transComponents = useMemo(
    () => ({
      status: <Text nested variant="body-s-semi" {...statusColorProps} />,
    }),
    [statusColorProps],
  );

  if (!status) {
    return null;
  }

  return (
    <Box alignItems="center" gap="space-400">
      <StatusTitleText locKey={`status_${variant}_title`} />
      <Text variant="body-s" color="darkSurfacePrimary" textAlign="center">
        <Trans
          ns="status"
          i18nKey={`status_${variant}_message_a`}
          components={transComponents}
          values={{ status: status.playerStatus }}
        />
      </Text>
      <Text variant="body-s" color="darkSurfacePrimary" textAlign="center">
        <Trans
          ns="status"
          i18nKey={`status_${variant}_message_b`}
          components={transComponents}
          values={{ status: status.playerStatus }}
        />
      </Text>
      <StatusInstructions status={status} />
      <StatusResetDisclaimer status={status} />
    </Box>
  );
}

export default memo(StatusUpdated);
